import { View } from 'react-native';

import { COLORS } from './Basics';
import { useStore } from '../store/Context';

function isSupervisorEmbed(lorentz) {
  if (lorentz?.supervisorEmbed) return true;
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return (
    params.get('embed') === 'supervisor' ||
    params.get('source') === 'supervisor'
  );
}

export const Container = ({ children }) => {
  const { size: { width, height, fill }, lorentz = {} } = useStore();
  const embed = isSupervisorEmbed(lorentz) || fill;

  if (embed) {
    return (
      <View
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          backgroundColor: COLORS.app
        }}
      >
        {children}
      </View>
    );
  }

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: COLORS.backColor
      }}
    >
      <View style={{ width, height, backgroundColor: COLORS.app }}>
        {children}
      </View>
    </View>
  );
};
